import { format } from 'date-fns';
import { ResumedSignupData, resumeSignupFromLeadID } from 'domains/signupDirect/ResumeLead/resumeLead';
import { ResumeSignupLeadFormType } from 'domains/signupDirect/ResumeLead/resumeSchema';

export const onSubmitLeadVerification = async (
  data: ResumeSignupLeadFormType,
): Promise<ResumedSignupData | undefined> => {
  const result = await resumeSignupFromLeadID(data.leadID, {
    clientFirstName: data.firstName,
    clientLastName: data.lastName,
    dateOfBirth: format(new Date(data.dateOfBirth), 'MM-dd-yyyy'),
  });

  return result;
};
